export enum Role {
    SUPER_ADMIN = "SUPER_ADMIN",
    ADMIN = "ADMIN",
    PARTNER = "PARTNER",
    SUPER_USER = "SUPER_USER",
    PLANNER = "PLANNER",
    ANALYST = "ANALYST",
    SENSOR = "SENSOR"
}

export enum RoleAction {
    VIEW = 'VIEW',
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    OTP = 'OTP',
    RECALL = 'RECALL',
    CREATE_BUCKET = 'CREATE_BUCKET',
    SEND_INVITATION = 'SEND_INVITATION',
    SHARE_VIEW_TO_USER = 'SHARE_VIEW_TO_USER',
    SHARE_VIEW_TO_GROUP = 'SHARE_VIEW_TO_GROUP',
    MAP_LOCATION_CUSTOMER = 'MAP_LOCATION_CUSTOMER',
    VIEW_OVERVIEW = "VIEW_OVERVIEW",
    SUMMARY_REPORT = "SUMMARY_REPORT",
    VIEW_CREATE = "VIEW_CREATE",
    SECOND_FILTER_GRID = "SECOND_FILTER_GRID",
    CONNECT_DATA_POM = "CONNECT_DATA_POM",
    DIFFERENT_CUSTOMER_POM = "DIFFERENT_CUSTOMER_POM",
    SELECTION_TAG = "SELECTION_TAG",
    SELECTION_CATEGORY = "SELECTION_CATEGORY",
    USER_PERMISSION = "USER_PERMISSION",
    IMPERSONATION = 'IMPERSONATION',
    DELETE_VIEW_ADVANCED = "DELETE_VIEW_ADVANCED",
    FRAMES = 'FRAMES',
}